import image_1 from './assets/image-1.webp';
import image_2 from './assets/image-2.webp';
import image_3 from './assets/image-3.webp';
import image_1_m from './assets/image-1-m.webp';
import image_2_m from './assets/image-3-m.webp';
import image_3_m from './assets/image-2-m.webp';

export const featureContent = {
  buttonLabel: 'выбрать квартиру',
  buttonHref: ' https://prichal-dom.ru/genplan',
  list: [
    {
      title_1: 'Малоэтажный',
      title_2: 'квартал',
      text_1: 'дома не нависают над вами,',
      text_2: 'а гармонично вписываются в ландшафт',
      image: image_1,
      image_m: image_1_m,
    },
    {
      title_1: 'Собственная',
      title_2: 'набережная',
      text_1: 'и бульвар, доступные',
      text_2: 'жителям комплекса',
      image: image_2,
      image_m: image_2_m,
    },
    {
      title_1: 'Технологичность',
      text_1: 'чистая вода из-под крана,',
      text_2: 'биометрические замки и управление домом через смартфон',
      image: image_3,
      image_m: image_3_m,
    },
  ],
};
